export default "__VITE_ASSET__d498a891__"